/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestDetail
 */
export interface AccessRequestDetail {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    app_external_connection_id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    identifier_from_source: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    external_identity_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestDetail
     */
    person_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    target: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestDetail
     */
    requested_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestDetail
     */
    expires_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    revert_action?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestDetail
     */
    revert_action_target?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestDetail
     */
    reverted?: boolean;
}

/**
 * Check if a given object implements the AccessRequestDetail interface.
 */
export function instanceOfAccessRequestDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "app_external_connection_id" in value;
    isInstance = isInstance && "identifier_from_source" in value;
    isInstance = isInstance && "external_identity_id" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "target" in value;

    return isInstance;
}

export function AccessRequestDetailFromJSON(json: any): AccessRequestDetail {
    return AccessRequestDetailFromJSONTyped(json, false);
}

export function AccessRequestDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'app_external_connection_id': json['app_external_connection_id'],
        'identifier_from_source': json['identifier_from_source'],
        'external_identity_id': json['external_identity_id'],
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'status': json['status'],
        'action': json['action'],
        'target': json['target'],
        'requested_at': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'expires_at': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'revert_action': !exists(json, 'revert_action') ? undefined : json['revert_action'],
        'revert_action_target': !exists(json, 'revert_action_target') ? undefined : json['revert_action_target'],
        'reverted': !exists(json, 'reverted') ? undefined : json['reverted'],
    };
}

export function AccessRequestDetailToJSON(value?: AccessRequestDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organization_id,
        'app_external_connection_id': value.app_external_connection_id,
        'identifier_from_source': value.identifier_from_source,
        'external_identity_id': value.external_identity_id,
        'person_id': value.person_id,
        'status': value.status,
        'action': value.action,
        'target': value.target,
        'requested_at': value.requested_at === undefined ? undefined : (value.requested_at.toISOString()),
        'expires_at': value.expires_at === undefined ? undefined : (value.expires_at.toISOString()),
        'reason': value.reason,
        'revert_action': value.revert_action,
        'revert_action_target': value.revert_action_target,
        'reverted': value.reverted,
    };
}

